import React, { useContext, useEffect, useRef, useState } from "react";
import { trackPromise } from "react-promise-tracker";
import DownloadIcon from "assets/icons/document-download.png";
import EditActiveIcon from "assets/icons/edit-3.png";
import EditIcon from "assets/icons/edit-3.svg";
import Wave from "components/audioPlayer";
import { CustomButton } from "components/component-styles/buttons/index.styled";
import RootLayout from "components/layout/rootLayout";
import {
  DownloadChangeButton,
  FeedBackDiv,
  LoaderAudio,
  Rating,
  TextEditContainer,
  TextEditorWrapper,
  VoiceContainer,
} from "./index.styled";
import { BiDislike, BiLike } from "react-icons/bi";
import { useLocation, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { env } from ".env";
import ReadMode from "components/ReadMode/readMode";
import Delayed from "components/delayed";

import useWindowDimensions from "hooks/useWindowDimensions";
import Archives from "services/apis/archivesAPI";
import { logger } from "utils/logger/logger";

export default function TextEditFeedback() {
  const dim = useWindowDimensions();
  const [timeStampFea, setTimeStampFea] = useState([]);
  const [audioData, setAudioData] = useState("");
  const [audioDataTitle, setAudioDataTitle] = useState("");
  const [editedAudioTitle, setEditedAudioTitle] = useState(
    JSON.parse(window.localStorage.getItem("SET_AUDIO_TITLE"))
  );
  const [audioResultArchive, setAudioResultArchive] = useState("");
  const [audioDownloaded, setAudioDownloaded] = useState("");
  const titileChange = useRef(null);

  const location = useLocation();
  function removeExtension(filename) {
    return filename.substring(0, filename.lastIndexOf(".")) || filename;
  }
  const params = useParams(); //get url id param
  const [feedbackState, setFeedbackState] = useState(null);

  async function handleFeedback(e) {
    const action = e.target.getAttribute("data-id");

    // it is null and clicked on text not the green or red hand its a temporary  patch/hotfix
    if (action === null) return;
    let feedback = {
      feedback: action,
    };

    const response = await new Archives(feedback).patchFeedback(params.id);
    if (response.type) {
      setFeedbackState(action);
    } else {
      toast.error(response.message);
    }
  }
  const fetchBasedOnArchiveId = async () => {
    // ------------------>

    const response = await new Archives().getSingleArchives(params.id);

    if (response.type) {
      const data = response.data;
      const res = response.data.data;
      const timestamp = res.result?.features?.timestamps;
      logger.log()(timestamp);
      setTimeStampFea(timestamp);
      setFeedbackState(res.feedback);
      setEditTitle(data.data.title);
      setInitalTitle(data.data.title);
      setAudioData(data);

      if (data.status === "success") {
        if (data.data.result.aiResult) {
          const audioPath = `${env.REACT_APP_BASE_URL}download/${data.data.result.aiResult}`;

          setAudioDownloaded(audioPath);
          const aiText = await fetch(
            `${env.REACT_APP_BASE_URL}download/${data.data.text}`,
            {
              headers: {
                authorization: localStorage.getItem("token"),
              },
            }
          );

          const res = aiText.text();

          setAudioResultArchive(await res);
        }
      }
    } else {
      toast.error(response.message);
    }
  };

  useEffect(() => {
    trackPromise(fetchBasedOnArchiveId());
  }, []);

  useEffect(() => {
    const dataLink = window.localStorage.getItem("SET_AUDIO_LINK");
    const dataTitle = window.localStorage.getItem("SET_AUDIO_TITLE");
    setAudioDataTitle(JSON.parse(dataTitle));
  }, []);

  useEffect(() => {
    if (location.state === false) {
      document.getElementById("editor").addEventListener("input", (e) => {
        setEditedAudioTitle(e.target.textContent);
      });
    }
  }, [titileChange, location.state]);

  const [editTitle, setEditTitle] = useState("");
  const [initalTitle, setInitalTitle] = useState("");
  const [activeEdit, setActiveEdit] = useState(true);

  async function submitTitle() {
    setActiveEdit(true);

    const response = await new Archives({
      title: editTitle ? editTitle : initalTitle,
    }).patchEditTitle(params.id);

    if (!response.type) {
      toast.error(response.message);
    }
  }

  async function downloadOnClick(e) {
    e.stopPropagation();
    e.preventDefault();

    await new Archives()
      .getDownloadTextArchives(audioData.data.result.aiResult)
      .then((r) => {
        // const div = e.target;

        const a = document.createElement("a");
        const data = r.data;

        const file = new Blob([data], { type: "audio/mpeg" });

        a.href = window.URL.createObjectURL(file);

        a.download = `${editTitle}.mp3`;

        // div.appendChild(a);

        a.click();

        a.remove();
      });
  }
  const [timeStamp, setTimeStamp] = useState(null);

  return (
    <RootLayout>
      <TextEditContainer>
        <VoiceContainer>
          <div className="title">
            <div className="editIcon">
              {!activeEdit ? (
                <img
                  src={EditActiveIcon}
                  onClick={() => setActiveEdit(!activeEdit)}
                  alt="edit icon"
                />
              ) : (
                <img
                  src={EditIcon}
                  onClick={() => setActiveEdit(!activeEdit)}
                  alt="edit icon"
                />
              )}
            </div>
            <div className="titleEdit">
              <input
                onBlur={submitTitle}
                onChange={(e) => setEditTitle(e.target.value)}
                className={!activeEdit && "active"}
                defaultValue={initalTitle}
                type="text"
                placeholder={initalTitle}
                disabled={activeEdit}
              />
            </div>
          </div>
          <div className="audio-container">
            {audioDownloaded ? (
              <Delayed>
                <Wave
                  audio={audioDownloaded}
                  speaker={false}
                  timeCallback={(time) => setTimeStamp(time)}
                />
              </Delayed>
            ) : (
              <LoaderAudio>
                <h4>اطلاعات شما در حال بارگذاری است.</h4>
              </LoaderAudio>
            )}
          </div>
        </VoiceContainer>
        <TextEditorWrapper>
          {" "}
          {audioResultArchive && (
            <ReadMode timeStamp={timeStamp} timeStampFea={timeStampFea} />
          )}
        </TextEditorWrapper>
        <FeedBackDiv>
          {dim.width > 1024 ? (
            <Rating onClick={(e) => handleFeedback(e)}>
              <p> به این تبدیل امتیاز دهید:</p>
              <div className={`like ${feedbackState == "1" && "active"}`}>
                <div className="glass" data-id="1"></div>
                <BiLike />
              </div>
              <div className={`like ${feedbackState == "0" && "active"}`}>
                <div className="glass" data-id="0"></div>
                <BiDislike />
              </div>
            </Rating>
          ) : (
            ""
          )}

          <DownloadChangeButton>
            <CustomButton
              fontWeight="700"
              background="#6CAEFF"
              backgroundHover="#FFF"
              borderColor="#6CAEFF"
              borderColorHover="#6CAEFF"
              colorHover="#6CAEFF"
              onClick={downloadOnClick}
            >
              <span>دانلود فایل صوتی</span>
              <img src={DownloadIcon} />
            </CustomButton>
          </DownloadChangeButton>
        </FeedBackDiv>
      </TextEditContainer>
    </RootLayout>
  );
}
